export default "__VITE_ASSET__Dc20tkrK__"